import React from 'react';

const AuthTabs = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'login', label: '로그인', labelEn: 'Login' },
    { id: 'register', label: '회원가입', labelEn: 'Register' }
  ];

  return (
    <div className="flex items-center space-x-2 p-1 bg-muted rounded-lg mb-6 md:mb-8">
      {tabs?.map((tab) => (
        <button
          key={tab?.id}
          onClick={() => onTabChange(tab?.id)}
          className={`flex-1 px-4 md:px-6 py-2.5 md:py-3 rounded-md text-sm md:text-base font-medium transition-gaming ${
            activeTab === tab?.id
              ? 'bg-primary text-primary-foreground shadow-gaming-sm'
              : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'
          }`}
        >
          {tab?.label}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;